import type { Compte, Sens } from "../api/client";
// Les blocs communs viennent de la charte du cabinet : un indicateur, un
// message ou un en-tête de page se dessinent de la même façon dans les trois
// applications.
export { Chargement, EnTetePage, Indicateur, Message, Vide } from "@cabinet/charte";

/* ------------------------------------------------------------------ */
/*  Étiquettes                                                         */
/* ------------------------------------------------------------------ */

const LIBELLE_SENS: Record<Sens, string> = {
  DEBIT: "Débit",
  CREDIT: "Crédit",
};

/**
 * Sens normal d'un compte.
 *
 * Il ne contraint pas la saisie : il dit dans quel sens le solde est attendu,
 * et c'est ce qui permettra plus tard de signaler un solde anormal.
 */
export function EtiquetteSens({ sens }: { sens: Sens }) {
  return <span className="etiquette neutre">{LIBELLE_SENS[sens]}</span>;
}

/**
 * Caractéristiques de gestion d'un compte.
 *
 * Un compte d'agrégation ou un compte collectif ne reçoit pas d'écriture ; le
 * dire ici évite de le découvrir au moment de la saisie.
 */
export function JetonsDeCompte({ compte }: { compte: Compte }) {
  return (
    <div className="jetons">
      {compte.mouvementable ? (
        <span className="etiquette succes">Mouvementable</span>
      ) : (
        <span className="etiquette neutre">Agrégation</span>
      )}
      {compte.collectif && <span className="etiquette info">Collectif</span>}
      {compte.lettrable && <span className="etiquette neutre">Lettrable</span>}
      {compte.rapprochable && <span className="etiquette neutre">Rapprochable</span>}
      {compte.auxiliarisable && <span className="etiquette neutre">Auxiliaires</span>}
      {compte.codeDeTva != null && (
        <span className="etiquette avertissement">TVA {compte.codeDeTva}</span>
      )}
    </div>
  );
}

